import { render, staticRenderFns } from "./LayoutExploreEvent.vue?vue&type=template&id=6238e4d8&"
var script = {}
import style0 from "./LayoutExploreEvent.vue?vue&type=style&index=0&id=6238e4d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports